import { SVGAttributes } from 'react';

const My = (props: SVGAttributes<SVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 12C0 5.376 5.376 0 12 0C18.624 0 24 5.376 24 12C24 18.624 18.624 24 12 24C5.376 24 0 18.624 0 12ZM12 6C13.3833 6 14.5 7.11667 14.5 8.5C14.5 9.88333 13.3833 11 12 11C10.6167 11 9.5 9.88333 9.5 8.5C9.5 7.11667 10.6167 6 12 6ZM12 17.8333C9.91667 17.8333 8.075 16.7666 7 15.1499C7.025 13.4916 10.3333 12.5833 12 12.5833C13.6583 12.5833 16.975 13.4916 17 15.1499C15.925 16.7666 14.0833 17.8333 12 17.8333Z"
            fill="currentColor"
        />
    </svg>
);
export default My;
